/**
 * Sepet satırı seçenekleri: hediye mesajı + teslimat günü/saati.
 *
 * Her satırın kendi değerleri vardır; düzenleme tek paylaşılan <dialog> üzerinden yapılır.
 * Kaydetme /cart/change.js'e gider. Shopify o istekte gönderilen properties nesnesiyle
 * satırın MEVCUT properties'inin tamamını değiştirir (merge etmez), bu yüzden her kayıtta
 * bütün alanlar birlikte gönderilir.
 */

const CART_LINE_PROPERTY_MAP = {
  deliveryDate: 'Teslimat günü',
  deliverySlot: 'Teslimat saati',
  recipient: 'Hediye alıcısı',
  sender: 'Gönderen',
  message: 'Hediye mesajı',
  timing: 'Mesaj zamanı',
  msgDate: 'Mesaj tarihi',
  msgTime: 'Mesaj saati',
  phone: '_Alıcı telefonu',
};

class CartLineOptions {
  constructor(dialog) {
    this.dialog = dialog;
    this.form = dialog.querySelector('[data-cart-line-options-form]');
    this.productLabel = dialog.querySelector('[data-cart-line-options-product]');
    this.cutoffNote = dialog.querySelector('[data-cart-line-options-cutoff]');
    this.counter = dialog.querySelector('[data-cart-line-counter]');
    this.status = dialog.querySelector('[data-cart-line-status]');
    this.saveButton = dialog.querySelector('[data-cart-line-save]');
    this.timingWrapper = dialog.querySelector('[data-cart-line-timing-wrapper]');
    this.timingButtons = [...dialog.querySelectorAll('[data-cart-line-timing]')];
    this.laterFields = dialog.querySelector('[data-cart-line-later-fields]');

    this.errors = {
      delivery: dialog.querySelector('[data-cart-line-delivery-error]'),
      contact: dialog.querySelector('[data-cart-line-contact-error]'),
      past: dialog.querySelector('[data-cart-line-past-error]'),
      generic: dialog.querySelector('[data-cart-line-generic-error]'),
    };

    this.fields = Object.fromEntries(
      [...dialog.querySelectorAll('[data-cart-line-field]')].map((el) => [el.dataset.cartLineField, el])
    );

    this.cutoffHour = Number(dialog.dataset.cutoffHour || 16);
    this.noteOpenGeneration = 0;
    this.noteDirty = false;
    this.saving = false;
    this.bind();
  }

  bind() {
    this.saveButton.addEventListener('click', () => this.save());
    this.dialog.querySelectorAll('[data-cart-line-options-close]').forEach((button) => {
      button.addEventListener('click', () => this.dialog.close());
    });
    if (this.fields.phone) {
      this.fields.phone.addEventListener('input', () => {
        const once = this.fields.phone.value;
        const sonra = this.telefonBicimle(once);
        if (once !== sonra) {
          this.fields.phone.value = sonra;
          // İmleç sona alınır; biçimlendirme sırasında ortada kalmasın.
          this.fields.phone.setSelectionRange(sonra.length, sonra.length);
        }
      });
    }

    this.fields.deliveryDate.addEventListener('change', () => this.slotlariGunlukSaatleGuncelle());
    this.fields.message.addEventListener('input', () => this.updateCounter());
    this.fields.message.addEventListener('input', () => this.syncTimingVisibility());
    this.timingButtons.forEach((button) => {
      button.addEventListener('click', () => this.selectTiming(button.dataset.cartLineTiming));
    });
    Object.values(this.fields).forEach((field) => {
      field.addEventListener('input', () => this.clearErrors());
      field.addEventListener('change', () => this.clearErrors());
    });

    this.fields.note?.addEventListener('input', () => { this.noteDirty = true; });

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-cart-line-options-trigger]');
      if (trigger) this.open(trigger);
    });

    // "Sepete ekle" önce pencereyi açar. Yakalama aşamasında dinlenir ki temanın kendi
    // form gönderimi devreye girmeden durdurulabilsin. Bilgiler alındıktan sonra aynı
    // düğme yeniden tetiklenir ve form normal akışıyla gönderilir.
    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('[data-line-options-required]');
        if (!button) return;
        const form = button.closest('form');
        if (!form || form.dataset.lineOptionsReady === 'true') return;

        event.preventDefault();
        event.stopPropagation();
        this.openForProduct(form, button);
      },
      true
    );

    // Sepet kendi bölümlerini bizim güncellememizden sonra da tazeleyebiliyor ve o HTML
    // ödeme düğmesini yeniden kilitliyor. Kilidi her sepet güncellemesinden sonra tekrar
    // değerlendir; böylece hangi tazeleme en sona kalırsa kalsın sonuç doğru olur.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        requestAnimationFrame(() => this.refreshCheckoutLock());
      });
    }

    this.refreshCheckoutLock();
  }

  /**
   * Ödemeye geçiş kilidi.
   *
   * Teslimat günü olmayan satır varsa ödeme düğmesi kapalı kalır. İlk yüklemede kilit
   * Liquid'de kurulur; burada sepet güncellendikten sonra yeniden değerlendirilir.
   */
  refreshCheckoutLock() {
    const tetikler = [...document.querySelectorAll('[data-cart-line-options-trigger]')];
    if (!tetikler.length) return;
    const eksik = tetikler.some((t) => !t.dataset.deliveryDate);

    document.querySelectorAll('#checkout, #CartDrawer-Checkout').forEach((dugme) => {
      dugme.disabled = eksik;
    });

    document.querySelectorAll('.cart__checkout-blocked').forEach((uyari) => {
      uyari.hidden = !eksik;
    });
  }

  /** Metindeki rakamları çıkarır. */
  rakamlar(deger) {
    return String(deger || '').replace(/\D/g, '');
  }

  /**
   * Türkiye cep numarası biçimi: 5xx xxx xx xx.
   *
   * Ülke kodu alanın solunda sabit duruyor, kullanıcı yalnız 10 haneyi giriyor.
   * Baştaki 0 ve yapıştırılan +90 / 90 önekleri atılır; alan yalnız rakam kabul eder.
   */
  telefonBicimle(ham) {
    let r = this.rakamlar(ham);
    if (r.startsWith('90')) r = r.slice(2);
    if (r.startsWith('0')) r = r.replace(/^0+/, '');
    r = r.slice(0, 10);
    const parca = [r.slice(0, 3), r.slice(3, 6), r.slice(6, 8), r.slice(8, 10)].filter(Boolean);
    return parca.join(' ');
  }

  /** Siparişe yazılacak tam numara. */
  telefonTam(deger) {
    const r = this.rakamlar(this.telefonBicimle(deger));
    return r.length === 10 ? `+90 ${this.telefonBicimle(deger)}` : '';
  }

  /** Europe/Istanbul duvar saati; sunucu ve tarayıcı saat dilimi farkını devre dışı bırakır. */
  getIstanbulNow() {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Istanbul',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    })
      .formatToParts(new Date())
      .reduce((acc, part) => {
        acc[part.type] = part.value;
        return acc;
      }, {});

    return {
      date: `${parts.year}-${parts.month}-${parts.day}`,
      time: `${parts.hour}:${parts.minute}`,
      hour: Number(parts.hour),
    };
  }

  /**
   * Seçilen günün çalışma saatleri dışındaki teslimat aralıklarını gizler.
   *
   * Pazar günü mağaza 12.00-17.00 açık; önceden 09:00-12:00 ve 18:00-21:00 aralıkları
   * da seçilebiliyordu ve müşteri mağazanın kapalı olduğu bir saate sipariş veriyordu.
   * Bir aralık, başlangıcı çalışma penceresinin içindeyse geçerli sayılıyor.
   *
   * Saatler burada tanımlı; panelden yönetilmesi istenirse tema ayarına taşınabilir.
   * 0 = Pazar.
   */
  calismaSaatleri(gunIndeksi) {
    const tablo = {
      0: { acilis: 12, kapanis: 17 },
    };
    return tablo[gunIndeksi] || { acilis: 9, kapanis: 21 };
  }

  slotlariGunlukSaatleGuncelle() {
    const secim = this.fields.deliveryDate.value;
    const secenekler = [...this.fields.deliverySlot.options];
    if (!secim) {
      secenekler.forEach((o) => { o.hidden = false; o.disabled = false; });
      return;
    }

    const [yil, ay, gun] = secim.split('-').map(Number);
    const gunIndeksi = new Date(Date.UTC(yil, ay - 1, gun)).getUTCDay();
    const { acilis, kapanis } = this.calismaSaatleri(gunIndeksi);

    secenekler.forEach((secenek) => {
      if (!secenek.value) return; // "Saat aralığı seçin" satırı hep dursun
      const baslangic = Number(secenek.value.split(':')[0]);
      const uygun = Number.isNaN(baslangic) || (baslangic >= acilis && baslangic < kapanis);
      secenek.hidden = !uygun;
      secenek.disabled = !uygun;
    });
  }

  addDays(isoDate, days) {
    const [year, month, day] = isoDate.split('-').map(Number);
    const shifted = new Date(Date.UTC(year, month - 1, day + days));
    return shifted.toISOString().slice(0, 10);
  }

  /** Kesim saati geçtiyse aynı gün teslimat kapanır; en erken yarın seçilebilir. */
  getEarliestDeliveryDate(now) {
    return now.hour >= this.cutoffHour ? this.addDays(now.date, 1) : now.date;
  }

  /** Ürün sayfası modu: sepete eklemeden önce bilgileri topla. */
  openForProduct(form, button) {
    if (this.saving) return;
    this.mode = 'product';
    this.productForm = form;
    this.productButton = button;

    const sahte = document.createElement('button');
    sahte.dataset.productTitle = this.dialog.dataset.productTitleFallback || '';
    Object.entries(this.readProductDraft(form)).forEach(([key, value]) => {
      sahte.dataset[key] = value;
    });
    this.open(sahte);
  }

  /** Formdaki gizli alanlarda daha önce doldurulmuş değer varsa pencereye geri yükle. */
  readProductDraft(form) {
    const taslak = {};
    form.querySelectorAll('[data-line-option-property]').forEach((input) => {
      if (!input.disabled && input.value) taslak[input.dataset.lineOptionProperty] = input.value;
    });
    return taslak;
  }

  open(trigger) {
    if (this.saving) return;
    const noteGeneration = ++this.noteOpenGeneration;
    this.noteDirty = false;
    const now = this.getIstanbulNow();
    const earliest = this.getEarliestDeliveryDate(now);

    if (trigger.dataset.line) this.mode = 'cart';
    this.currentLine = trigger.dataset.line;
    this.productLabel.textContent = trigger.dataset.productTitle || '';

    // Cekmece her sayfada gövdede duruyor ve DOM'da sepet sayfasindan ONCE geliyor;
    // genel bir querySelector hep cekmeceyi secer ve sepet sayfasinin alt bilgisi
    // (odeme dugmesi) tazelenmeden kalir. Tiklanan dugmenin kendi kapsayicisi kullanilir.
    this.currentCartElement =
      trigger.closest('cart-drawer-items') ||
      trigger.closest('cart-items') ||
      document.querySelector('cart-items, cart-drawer-items');

    this.fields.deliveryDate.min = earliest;
    this.fields.deliveryDate.max = this.addDays(now.date, 180);
    this.fields.msgDate.min = now.date;
    this.fields.msgDate.max = this.addDays(now.date, 180);

    this.cutoffNote.textContent = this.dialog.dataset.cutoffNote.replace('{{ hour }}', `${this.cutoffHour}:00`);

    this.fields.deliveryDate.value = trigger.dataset.deliveryDate || '';
    this.slotlariGunlukSaatleGuncelle();
    this.fields.deliverySlot.value = trigger.dataset.deliverySlot || '';
    // Devralinan slot o gun kapaliysa secim bosalir; musteri yeniden secmek zorunda kalir.
    if (this.fields.deliverySlot.selectedIndex === -1) this.fields.deliverySlot.value = '';
    this.fields.recipient.value = trigger.dataset.recipient || '';
    this.fields.sender.value = trigger.dataset.sender || '';
    this.fields.message.value = trigger.dataset.message || '';
    this.fields.phone.value = this.telefonBicimle(trigger.dataset.phone || '');
    this.fields.msgDate.value = trigger.dataset.msgDate || '';
    this.fields.msgTime.value = trigger.dataset.msgTime || '';

    const savedTiming = this.timingButtons.find((b) => b.dataset.propertyValue === trigger.dataset.timing);
    this.selectTiming(savedTiming?.dataset.cartLineTiming || 'delivery');

    if (this.fields.note) {
      // Sipariş notu sepet düzeyinde; pencere her açıldığında güncel değer okunur.
      this.mevcutNot = undefined;
      this.fields.note.value = '';
      this.noteRead = fetch(`${routes.cart_url}.js`)
        .then((r) => {
          if (!r.ok) throw new Error('note-read');
          return r.json();
        })
        .then((c) => {
          if (noteGeneration !== this.noteOpenGeneration) return;
          this.mevcutNot = c.note || '';
          if (!this.noteDirty) this.fields.note.value = this.mevcutNot;
        })
        .catch(() => {});
    }

    this.updateCounter();
    this.syncTimingVisibility();
    this.clearErrors();
    this.dialog.showModal();
  }

  /** Mesaj zamanlaması yalnızca hediye mesajı yazıldıysa anlamlı. */
  syncTimingVisibility() {
    this.timingWrapper.hidden = this.fields.message.value.trim().length === 0;
  }

  selectTiming(timing) {
    this.selectedTiming = timing;
    this.timingButtons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.cartLineTiming === timing));
    });
    const later = timing === 'later';
    this.laterFields.hidden = !later;
    if (!later) {
      this.fields.msgDate.value = '';
      this.fields.msgTime.value = '';
    }
  }

  updateCounter() {
    this.counter.textContent = `${this.fields.message.value.length}/210`;
  }

  clearErrors() {
    Object.values(this.errors).forEach((el) => {
      el.hidden = true;
    });
    Object.values(this.fields).forEach((field) => field.removeAttribute('aria-invalid'));
  }

  showError(key, message, fields = []) {
    this.errors[key].textContent = message;
    this.errors[key].hidden = false;
    fields.forEach((field) => field.setAttribute('aria-invalid', 'true'));
  }

  validate() {
    this.clearErrors();
    const now = this.getIstanbulNow();
    const earliest = this.getEarliestDeliveryDate(now);
    let firstInvalid;

    if (!this.fields.deliveryDate.value || !this.fields.deliverySlot.value) {
      this.showError('delivery', this.dialog.dataset.deliveryError, [
        this.fields.deliveryDate,
        this.fields.deliverySlot,
      ]);
      firstInvalid = this.fields.deliveryDate.value ? this.fields.deliverySlot : this.fields.deliveryDate;
    } else if (this.fields.deliveryDate.value < earliest) {
      this.showError('delivery', this.dialog.dataset.pastError, [this.fields.deliveryDate]);
      firstInvalid = this.fields.deliveryDate;
    }

    const hasMessage = this.fields.message.value.trim().length > 0;

    // Mesaj varsa alıcının telefonu zorunlu: kart mesajını iletebilmek için tek iletişim yolu.
    if (hasMessage && this.rakamlar(this.fields.phone.value).length !== 10) {
      this.showError('contact', this.dialog.dataset.contactError, [this.fields.phone]);
      firstInvalid ||= this.fields.phone;
    }

    if (hasMessage && this.selectedTiming === 'later') {
      if (!this.fields.msgDate.value || !this.fields.msgTime.value) {
        this.showError('past', this.dialog.dataset.pastError, [this.fields.msgDate, this.fields.msgTime]);
        firstInvalid ||= this.fields.msgDate;
      } else if (`${this.fields.msgDate.value}T${this.fields.msgTime.value}` <= `${now.date}T${now.time}`) {
        this.showError('past', this.dialog.dataset.pastError, [this.fields.msgDate, this.fields.msgTime]);
        firstInvalid ||= this.fields.msgTime;
      }
    }

    if (firstInvalid) {
      firstInvalid.focus();
      return false;
    }
    return true;
  }

  /** Sipariş notu satır özelliği değil; ayrı uçtan kaydedilir. */
  async siparisNotunuKaydet() {
    if (!this.fields.note) return;
    const yeni = this.fields.note.value;
    if (typeof this.mevcutNot === 'string' && yeni === this.mevcutNot) return;
    if (this.mevcutNot === undefined && !this.noteDirty && !yeni) return;
    const response = await fetch(`${routes.cart_update_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: yeni }),
    });
    if (!response.ok) throw new Error('note-save');
    this.mevcutNot = yeni;
  }

  collectProperties() {
    const hasMessage = this.fields.message.value.trim().length > 0;
    const selectedButton = this.timingButtons.find((b) => b.dataset.cartLineTiming === this.selectedTiming);

    const values = {
      deliveryDate: this.fields.deliveryDate.value,
      deliverySlot: this.fields.deliverySlot.value,
      recipient: hasMessage ? this.fields.recipient.value.trim() : '',
      sender: hasMessage ? this.fields.sender.value.trim() : '',
      message: this.fields.message.value.trim(),
      timing: hasMessage ? selectedButton?.dataset.propertyValue || '' : '',
      msgDate: hasMessage && this.selectedTiming === 'later' ? this.fields.msgDate.value : '',
      msgTime: hasMessage && this.selectedTiming === 'later' ? this.fields.msgTime.value : '',
      phone: hasMessage ? this.telefonTam(this.fields.phone.value) : '',
    };

    const properties = {};
    Object.entries(values).forEach(([key, value]) => {
      if (value) properties[CART_LINE_PROPERTY_MAP[key]] = value;
    });
    if (hasMessage) properties['_Mesaj saat dilimi'] = 'Europe/Istanbul';
    return properties;
  }

  /**
   * Sepet bölümlerini yerinde tazeler.
   *
   * Hem sepet sayfasını hem açık çekmeceyi kapsar; hangisi varsa o güncellenir. Bölüm
   * HTML'i /cart/change.js yanıtındaki `sections` alanından gelir, ek istek atılmaz.
   */
  async sepetBolumleriniTazele(data) {
    const hedefler = [
      { bolum: document.getElementById('main-cart-items')?.dataset.id, secici: '.js-contents', kok: '#main-cart-items' },
      { bolum: document.getElementById('main-cart-footer')?.dataset.id, secici: '.js-contents', kok: '#main-cart-footer' },
      { bolum: 'cart-drawer', secici: '.drawer__inner', kok: '#CartDrawer' },
      { bolum: 'cart-icon-bubble', secici: '.shopify-section', kok: '#cart-icon-bubble' },
    ].filter((h) => h.bolum && document.querySelector(h.kok));

    const gelen = data.sections || {};
    hedefler.forEach((h) => {
      const html = gelen[h.bolum];
      const hedef = document.querySelector(h.kok);
      if (!html || !hedef) return;
      const yeniDugum = new DOMParser().parseFromString(html, 'text/html').querySelector(h.secici);
      const eskiDugum = hedef.querySelector(h.secici) || hedef;
      if (yeniDugum && eskiDugum) eskiDugum.innerHTML = yeniDugum.innerHTML;
    });

    this.refreshCheckoutLock();
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-line-options' });
    }
  }

  /**
   * Kaydedilen teslimat gün/saatini sepetteki diğer satırlara da işler.
   *
   * Yalnız farklı olan satırlara istek atılır. Son isteğin yanıtı bölüm HTML'i
   * taşıdığı için geri döndürülür; çağıran onu doğrudan basar. Değişecek satır
   * yoksa null döner ve çağıran kendi yanıtıyla devam eder.
   */
  cartLineQuantity(item) {
    if (!Number.isSafeInteger(item?.quantity) || item.quantity < 1) throw new Error('cart-quantity');
    return item.quantity;
  }

  async teslimatiTumSatirlaraYay(gun, saat) {
    if (!gun || !saat) return null;

    const cartResponse = await fetch(`${routes.cart_url}.js`);
    if (!cartResponse.ok) throw new Error('cart-read');
    const sepet = await cartResponse.json();
    if (!Array.isArray(sepet.items)) throw new Error('cart-lines');
    const hedefler = sepet.items
      .map((item, i) => ({ item, satir: i + 1 }))
      .filter(({ item, satir }) => {
        if (satir === Number(this.currentLine)) return false;
        const p = item.properties || {};
        return p[CART_LINE_PROPERTY_MAP.deliveryDate] !== gun || p[CART_LINE_PROPERTY_MAP.deliverySlot] !== saat;
      });

    if (!hedefler.length) return null;
    // Do not start propagation when any target lacks a valid exact line quantity.
    hedefler.forEach(({ item }) => this.cartLineQuantity(item));

    const istenenBolumler = [
      document.getElementById('main-cart-items')?.dataset.id,
      document.getElementById('main-cart-footer')?.dataset.id,
      document.querySelector('#CartDrawer') ? 'cart-drawer' : null,
      'cart-icon-bubble',
    ].filter(Boolean);

    let sonYanit = null;
    for (const { item, satir } of hedefler) {
      const properties = { ...(item.properties || {}) };
      properties[CART_LINE_PROPERTY_MAP.deliveryDate] = gun;
      properties[CART_LINE_PROPERTY_MAP.deliverySlot] = saat;

      const yanit = await fetch(`${routes.cart_change_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: satir,
          quantity: this.cartLineQuantity(item),
          properties,
          sections: istenenBolumler,
          sections_url: window.location.pathname,
        }),
      });
      if (yanit.ok) sonYanit = await yanit.json();
    }

    return sonYanit;
  }

  async save() {
    if (this.saving || !this.validate()) return;
    this.saving = true;

    this.saveButton.disabled = true;
    const finishActivity = window.floralCartActivity?.begin();

    try {
      await this.noteRead;
      await this.siparisNotunuKaydet();
      if (!this.validate()) return;

      // Ürün sayfası modu: gizli alanları doldur ve formu normal akışıyla gönder.
      if (this.mode === 'product' && this.productForm) {
        const properties = this.collectProperties();
        this.productForm.querySelectorAll('[data-line-option-property]').forEach((input) => {
          const anahtar = input.dataset.lineOptionProperty;
          const propAdi = anahtar === 'timezone' ? '_Mesaj saat dilimi' : CART_LINE_PROPERTY_MAP[anahtar];
          const deger = properties[propAdi] || '';
          input.value = deger;
          input.disabled = !deger;
        });
        this.dialog.close();
        const productForm = this.productForm;
        productForm.dataset.lineOptionsReady = 'true';
        this.productButton.click();
        // Bir sonraki ekleme yine pencere açsın.
        setTimeout(() => {
          delete productForm.dataset.lineOptionsReady;
        }, 1000);
        return;
      }

      const istenenBolumler = [
        document.getElementById('main-cart-items')?.dataset.id,
        document.getElementById('main-cart-footer')?.dataset.id,
        document.querySelector('#CartDrawer') ? 'cart-drawer' : null,
        'cart-icon-bubble',
      ].filter(Boolean);

      const line = Number(this.currentLine);
      if (!Number.isSafeInteger(line) || line < 1) throw new Error('cart-line');
      const cartResponse = await fetch(`${routes.cart_url}.js`);
      if (!cartResponse.ok) throw new Error('cart-read');
      const cart = await cartResponse.json();
      if (!Array.isArray(cart.items)) throw new Error('cart-lines');
      const quantity = this.cartLineQuantity(cart.items[line - 1]);

      const body = JSON.stringify({
        line,
        quantity,
        properties: this.collectProperties(),
        sections: istenenBolumler,
        sections_url: window.location.pathname,
      });

      const response = await fetch(`${routes.cart_change_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body,
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        this.showError('generic', data.description || data.message || this.dialog.dataset.genericError);
        return;
      }

      this.status.textContent = this.dialog.dataset.statusSaved || '';

      // Teslimat bilgisi sipariş düzeyinde tek. Aynı sipariş tek araçla, tek seferde
      // çıkıyor; satır satır farklı gün/saat tutulması hem müşteriyi yanıltıyordu
      // (buket 12:00-15:00, çikolatası 18:00-21:00) hem de karşılığı yoktu. Hediye
      // mesajı satıra özel kalır, yalnız gün ve saat eşitlenir.
      const yayilan = await this.teslimatiTumSatirlaraYay(
        this.fields.deliveryDate.value,
        this.fields.deliverySlot.value
      );
      this.dialog.close();
      if (yayilan) {
        await this.sepetBolumleriniTazele(yayilan);
        return;
      }

      // Sayfa yenilenmiyor: çekmece açıkken yenileme çekmeceyi kapatıp kullanıcıyı
      // sayfanın başına atıyordu. Bunun yerine yalnız sepet bölümleri yeniden çizilir,
      // ardından ödeme kilidi tekrar değerlendirilir (Liquid'den gelen HTML kilidi
      // kendi sürümüyle yeniden kurabiliyor).
      await this.sepetBolumleriniTazele(data);
    } catch (error) {
      this.showError('generic', this.dialog.dataset.genericError);
    } finally {
      this.saving = false;
      this.saveButton.disabled = false;
      finishActivity?.();
    }
  }
}

function initCartLineOptions() {
  const dialog = document.querySelector('[data-cart-line-options-dialog]');
  if (!dialog || dialog.cartLineOptions) return;
  if (typeof dialog.showModal !== 'function') return;
  dialog.cartLineOptions = new CartLineOptions(dialog);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartLineOptions);
} else {
  initCartLineOptions();
}
